import React, { useContext } from 'react'
import {Card, Button } from '@mui/material'
import { Modal, LoadingOverlay, FlexView } from '../../components/common'
import { useHistory } from 'react-router-dom'
import { UserContext } from '../../stores/UserStore'
import VerificationImage from '../../assets/images/verification.png'
import ReCAPTCHA from "react-google-recaptcha"

const ValidateCaptcharModal = ({ isOpen, isLoading, onChange }) => {
  const history = useHistory()
  const { app } = useContext(UserContext)

  const onGoToLogin = () => {
    history.replace('/logout?app='+app.id)
  }
   
  return (<Modal isOpen={isOpen}>
    <LoadingOverlay borderRadius="card" visible={isLoading}/>
    <Card sx={{ width: '81vw', maxWidth: '410px',  height: '500px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent:'center', padding:'10px', margin: '0px' }}>
      <img src={VerificationImage} alt="Verification" style={{maxWidth: '150px'}}/>
      <FlexView style={{fontSize: '14px', fontWeight: 600}}  margin="60px 80px">Before you proceed to the SignIn, pelase complete the captchar below.</FlexView>
      <FlexView>
        <ReCAPTCHA hl="en"sitekey={process.env.REACT_APP_CAPTCHAR_SITE_KEY} onChange={onChange} />              
      </FlexView>
      <FlexView margin="20px 0px 0px 0px">
        <Button width="140px"  onClick={onGoToLogin} >Cancel</Button>
      </FlexView>          
    </Card>
  </Modal>)
}

export default ValidateCaptcharModal